
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	View,
	Platform,
} from "react-native";

import PageContainer from "./PageContainer";
import MainScroll from "./MainScroll";
import Card from "./Card";
import Heading from "ae-base/Base/Heading";
import BackButton from "ae-base/Base/BackButton";
import { 
	KEYBOARD_EXTRA_SPACING_ANDROID,
	KEYBOARD_EXTRA_SPACING_IOS,
	KEYBOARD_EXTRA_HEIGHT_SPACING_ANDROID,
	KEYBOARD_EXTRA_HEIGHT_SPACING_IOS,
} from "./keyboardConstants";

import Style from "ae-style";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";
import BlockView from "ae-base/Base/BlockView";

var styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		back: {
			marginLeft: Style.layout.marginBordered,
			marginTop: Style.layout.marginBordered,
		},
	},
	512: {
		back: {
			marginLeft: Style.layout.marginContent,
			marginTop: Style.layout.marginContentVertical,
		},
	},
});

export default function CardPage(props) {
	const {
		edit,
		title,
		icon,
		external,
		children,
		backTitle,
		saving,
		toast,
		screen,
		backAction,
	} = props;

	var backButton = backTitle ? (
		<View style={styles.back}>
			<BackButton title={backTitle} onPress={backAction} />
		</View>
	) : null;

	var heading = title ? (
		<Heading title={title} icon={icon} screen={screen}>
			<BlockView>{edit}</BlockView>
		</Heading>
	) : null;

	const keyboardExtraScrollSpacing = Platform.OS === "android" ? KEYBOARD_EXTRA_SPACING_ANDROID : KEYBOARD_EXTRA_SPACING_IOS;
	const keyboardExtraHeightSpacing = Platform.OS === "android" ? KEYBOARD_EXTRA_HEIGHT_SPACING_ANDROID : KEYBOARD_EXTRA_HEIGHT_SPACING_IOS;

	return (
		<PageContainer contrast saving={saving} toast={toast}>
			<MainScroll
				online={props.online}
				extraScrollHeight={keyboardExtraScrollSpacing}
				extraHeight={keyboardExtraHeightSpacing}
				fillHeight
			>
				{backButton}
				<Card>
					{heading}
					{children}
				</Card>
			</MainScroll>
			{external}
		</PageContainer>
	);
}
